const config = {
  NODE_ENV: process.env.NODE_ENV,
  ENV: process.env.NEXT_PUBLIC_ENV,
  DD_ENV: process.env.NEXT_PUBLIC_DD_ENV,
  DD_RELEASE_VERSION: process.env.NEXT_PUBLIC_DD_RELEASE_VERSION,
  MFD_API_HOST: process.env.NEXT_PUBLIC_MFD_API_HOST,
  API_HOST: process.env.NEXT_PUBLIC_API_HOST,
  APP_DOMAIN: process.env.NEXT_PUBLIC_APP_DOMAIN,
  AUTH_ENDPOINT: process.env.NEXT_PUBLIC_AUTH_ENDPOINT,
  GUEST_ENDPOINT: process.env.NEXT_PUBLIC_GUEST_ENDPOINT,
  SETTINGS_ENDPOINT: process.env.NEXT_PUBLIC_SETTINGS_ENDPOINT,
  GUESTAPP_ENDPOINT: process.env.NEXT_PUBLIC_GUESTAPP_ENDPOINT,
  FORM_FLOWS_ENDPOINT: process.env.NEXT_PUBLIC_FORM_FLOWS_ENDPOINT,
  FORM_FLOW_REQUEST_ENDPOINT:
    process.env.NEXT_PUBLIC_FORM_FLOW_REQUEST_ENDPOINT,
  GUESTBOOK_ENDPOINT: process.env.NEXT_PUBLIC_GUESTBOOK_ENDPOINT,
  FLEXIPASS_ENDPOINT: process.env.NEXT_PUBLIC_FLEXIPASS_ENDPOINT,
  REMOTELOCK_ENDPOINT: process.env.NEXT_PUBLIC_REMOTELOCK_ENDPOINT,
  UPSELL_PRODUCTS_ENDPOINT: process.env.NEXT_PUBLIC_UPSELL_PRODUCTS_ENDPOINT,
  UPSELL_CONFIGURATION_ENDPOINT:
    process.env.NEXT_PUBLIC_UPSELL_CONFIGURATION_ENDPOINT,
  UPSELL_ORDERS_ENDPOINT: process.env.NEXT_PUBLIC_UPSELL_ORDERS_ENDPOINT,
  PUSHER: {
    API_KEY: process.env.NEXT_PUBLIC_PUSHER_API_KEY,
  },
  CLOUDBEDS_API_HOST: process.env.NEXT_PUBLIC_CLOUDBEDS_API_HOST,
  CLOUDBEDS_US2_API_HOST: process.env.NEXT_PUBLIC_CLOUDBEDS_US2_API_HOST,
  PUBLIC_MEDIA_HOST: process.env.NEXT_PUBLIC_MEDIA_HOST,
  // Lets the document scanner accept a stored image instead of a live camera
  // capture, for testing OCR without a device. Opt-in per environment; absent
  // or anything other than "true" leaves it off, so production is off by
  // default.
  OCR_ALLOW_FILE_UPLOAD:
    process.env.NEXT_PUBLIC_OCR_ALLOW_FILE_UPLOAD === 'true',
  STRIPE_PUBLISHABLE_KEY: process.env.NEXT_STRIPE_PUBLISHABLE_KEY as string,
  STRIPE_PUBLISHABLE_KEY_TEST_MODE: process.env
    .NEXT_STRIPE_PUBLISHABLE_KEY_TEST_MODE as string,
} as const;

export default config;
